import { Table } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import placeholder from "../../../assets/images/placeholder.png";
import Moment from "react-moment";
import { fetchAllVehicles } from "../../../api/janjapan";
import Something from "../../../components/common/Something";
import ManageWrapper from "..";
import SyncModal from "./components/SyncModal";
import SyncBulk from "./components/SyncBulk";

export default function AllCars() {
  const [syncModal, setSyncModal] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);

  const [selected, setSelected] = useState<any>(null);

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 20,
    total: 0,
  });

  const params = `country_id=10&page=${pagination.page}&per_page=${pagination?.limit}`;

  const {
    data: cars,
    refetch,
    isLoading,
    isFetching,
    isFetched,
    isError,
  } = useQuery({
    queryKey: ["cars", pagination.page, pagination.limit, params],
    queryFn: () =>
      fetchAllVehicles({
        page: pagination.page,
        limit: pagination.limit,
        params,
      }),
  });

  const ids = cars?.data?.carList.map((item: any) => item.carId);

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  const columns = [
    {
      title: "S/N",
      width: 20,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
          {pagination?.page * pagination?.limit - pagination?.limit + index + 1}
        </span>
      ),
    },
    {
      title: "THUMBNAIL",
      width: 60,
      render: (record: any) => (
        <div className="">
          <div className="w-24 flex justify-center items-center">
            <img
              src={record?.imageUrl || placeholder}
              style={{ objectFit: "cover", width: "80%" }}
            />
          </div>
        </div>
      ),
    },
    {
      title: "CHASSIS",
      width: 100,
      render: (record: any) => (
        <div className="w-64">
          <div className="">
            Chassis: {record?.chassisNo} : {record?.carId}
          </div>
          <div className="text-gray-500">
            {record?.registrationYear} {record?.makerName} {record?.modelName}
          </div>
        </div>
      ),
    },
    {
      title: "STATE",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700">
          <div className="">
            <span className="font-bold">Status: {record?.cityName}</span>
          </div>
          <div className="text-gray-500">
            Sync with Veko App :
            {/* {record?.is_published ? (
              <span className="text-green-600 px-1">YES</span>
            ) : (
              <span className="text-red-600 px-1">NO</span>
            )} */}
          </div>
        </div>
      ),
    },
    {
      title: "DETAILS",
      width: 80,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.mileage ? (
            <div className="flex flex-col">
              <div className="">Mileage: {record?.mileage} Km</div>
            </div>
          ) : (
            "-"
          )}
          <div className="">
            <div className="">
              Engine Size: {record?.engineSize}, Seats: {record?.seats}, Doors:{" "}
              {record?.doors}, Color: {record?.colorName}
            </div>
          </div>
        </div>
      ),
    },

    {
      title: "CREATED",
      width: 50,
      render: (record: any) => (
        <div className="">
          <div className="text-gray-700 flex flex-col">
            <div className="font-bold">
              <Moment format="Do MMM, YYYY">{record?.registeredTime}</Moment>
            </div>
            <Moment fromNow>{record?.registeredTime}</Moment>
          </div>
        </div>
      ),
    },
    {
      title: "ACTIONS",
      width: 50,
      render: (record: any) => (
        <div className="flex justify-center items-center">
          <button
            onClick={() => {
              setSelected(record?.carId);
              setSyncModal(true);
            }}
            className="flex mx-2 justify-center items-center border px-4 py-1 h-10 hover:bg-gray-100"
          >
            Sync With Veko
          </button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    setPagination({ ...pagination, total: cars?.data?.pagination?.total });
  }, [cars, isFetched]);

  return (
    <ManageWrapper
      title={"🇯🇵 Stock"}
      subtitle={"List of source stock"}
      actions={
        <>
          <button
            onClick={() => setBulkModal(true)}
            className="border px-2 py-1"
          >
            Sync Batch (20)
          </button>
        </>
      }
    >
      <div className="">
        <div className="bg-white m-1">
          {isError ? (
            <Something refetch={refetch} isFetching={isFetching} />
          ) : (
            <div className="">
              <Table
                columns={columns}
                dataSource={cars?.data?.carList}
                size="small"
                bordered
                scroll={{ y: 525 }}
                loading={isLoading}
                rowKey="id"
                onRow={(record: any) => {
                  return {
                    onClick: () => {
                      setSelected(record?.carId);
                      setSyncModal(true);
                    },
                  };
                }}
                pagination={{
                  current: pagination?.page,
                  pageSize: pagination?.limit,
                  total: pagination?.total,
                }}
                onChange={(e: any) => handlePageChange(e)}
                rowClassName={"hover:cursor-pointer hover:bg-red-50"}
              />
            </div>
          )}
        </div>

        <SyncBulk
          isVisible={bulkModal}
          setVisible={setBulkModal}
          id={selected || ""}
          ids={ids || []}
        />

        <SyncModal
          isVisible={syncModal}
          setVisible={setSyncModal}
          id={selected || ""}
        />
      </div>
    </ManageWrapper>
  );
}
